export const config = [
  {
    id: "lily",
    name: "Lily",
    original: {
      audio:
        "https://eleven-public-cdn.elevenlabs.io/audio/professional-voice-cloning-landing/Lily%20Original%20v1.mp3",
      img: "/assets/images/voice-clones/lily.png",
    },
    cloned: {
      audio: "https://eleven-public-cdn.elevenlabs.io/audio/professional-voice-cloning-landing/Lily%20Clone%20v1.mp3",
      img: "/assets/images/voice-clones/lily-orb.jpg",
    },
  },
  {
    id: "chris",
    name: "Chris",
    original: {
      audio:
        "https://eleven-public-cdn.elevenlabs.io/audio/professional-voice-cloning-landing/Chris%20Original%20v1.mp3",
      img: "/assets/images/voice-clones/chris.png",
    },
    cloned: {
      audio: "https://eleven-public-cdn.elevenlabs.io/audio/professional-voice-cloning-landing/Chris%20Clone%20v1.mp3",
      img: "/assets/images/voice-clones/chris-orb.jpg",
    },
  },
  {
    id: "laura",
    name: "Laura",
    original: {
      audio:
        "https://eleven-public-cdn.elevenlabs.io/audio/professional-voice-cloning-landing/Laura%20Original%20v1.mp3",
      img: "/assets/images/voice-clones/laura.png",
    },
    cloned: {
      audio: "https://eleven-public-cdn.elevenlabs.io/audio/professional-voice-cloning-landing/Laura%20Clone%20v1.mp3",
      img: "/assets/images/voice-clones/laura-orb.jpg",
    },
  },
];
